<template>
    <div>
        <div
            v-if="isLoading"
            class="d-flex justify-content-center align-items-center"
            style="height: 100vh;"
        >
            <div>
                <pulse-loader
                    :color="'#b90066'"
                    :size="'40px'"
                />
                <p class="loading-text">
                    Laden...
                </p>
            </div>
        </div>

        <div v-else>
            <div>
                <div v-if="study.description !== ''">
                    <h3>Omschrijving</h3>
                    <div
                        class="html-content mb-5"
                        v-html="study.description"
                    />
                </div>

                <div v-if="study.secondaryOutcome !== ''">
                    <h3>Populatie</h3>
                    <div
                        class="html-content mb-5"
                        v-html="study.population"
                    />
                </div>

                <div v-if="study.primaryOutcome !== ''">
                    <h3>Primaire Doelstelling</h3>
                    <div
                        class="html-content mb-5"
                        v-html="study.primaryOutcome"
                    />
                </div>

                <div v-if="study.secondaryOutcome !== ''">
                    <h3>Secondaire Doelstelling</h3>
                    <div
                        class="html-content mb-5"
                        v-html="study.secondaryOutcome"
                    />
                </div>

                <div class="row">
                    <div class="col-lg-4">
                        <div
                            v-if="study.videoUrl"
                            class="enrollment-wrapper p-3 mb-4"
                        >
                            <b class="text-center pt-2">Video</b>

                            <div class="embed-responsive embed-responsive-16by9 mt-3">
                                <video
                                    controls
                                    controlsList="nodownload"
                                    :src="study.videoUrl"
                                />
                            </div>
                        </div>

                        <div
                            v-if="study.patientEnrollments && study.patientEnrollments.length > 0"
                            class="enrollment-wrapper p-3 mb-4"
                        >
                            <b class="text-center pt-2">Patiëntinclusie</b>
                            <enrollment-chart
                                class="p-4 enrollment-chart"
                                :enrolled="getPatientCount(study)"
                                :total-enrollment="study.patientsToBeIncluded"
                            />

                            <div class="legend">
                                <div>
                                    <div
                                        class="box"
                                        style="background-color: #63666a;"
                                    />
                                    <span>Gepland</span>
                                </div>

                                <div>
                                    <div
                                        class="box"
                                        style="background-color: #b90066;"
                                    />
                                    <span>Geïncludeerd</span>
                                </div>
                            </div>

                            <ul class="mt-3">
                                <li>
                                    Totaal aantal patiënten gepland: <span class="kpi">{{ study.patientsToBeIncluded }}</span>
                                </li>
                                <li>
                                    Geschatte LPLV: <span class="kpi">Q{{ study.lplvQuarter }} {{ study.lplvYear }}</span>
                                </li>
                            </ul>
                        </div>

                        <!--
                        <div class="stage-wrapper p-3">
                            <div
                                v-for="status in studyStatuses"
                                :key="status.label"
                                class="stage"
                                :class="{ active: status.value === study.studyStatus}"
                            >
                                <img :src="getImgUrl(status.image + (status.value > study.studyStatus ? '-gray' : '') + '.svg')">
                                <b>{{ status.label }}</b>
                            </div>
                        </div>
                        -->
                    </div>

                    <div
                        v-if="study.patientEnrollments && study.patientEnrollments.length > 0"
                        class="col-lg-8 col-md-12"
                    >
                        <div v-if="study.hasStratums">
                            <div
                                v-for="stratum in stratums"
                                :key="stratum.key"
                                class="site-enrollment-wrapper p-3"
                            >
                                <div class="meta-data">
                                    <b class="text-center pt-2">Patiëntinclusie per centrum</b>
                                    <div class="text-center">
                                        {{ stratum.label }}
                                    </div>
                                </div>
                                <site-enrollment-chart
                                    :enrollments="getEnrollmentForStratum(stratum)"
                                    class="pt-4 site-enrollment-chart"
                                />
                            </div>
                        </div>

                        <div v-else>
                            <div class="site-enrollment-wrapper p-3">
                                <div class="meta-data">
                                    <b class="text-center pt-2">Patiëntinclusie per centrum</b>
                                </div>
                                <site-enrollment-chart
                                    :enrollments="study.patientEnrollments"
                                    class="pt-4 site-enrollment-chart"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import studyService from '../services/study.service';
import studyStatuses from '../data/study-statuses';
import stratums from '../data/stratums';

import utils from '../utils';

import EnrollmentChart from '../charts/EnrollmentChart.vue';
import SiteEnrollmentChart from '../charts/SiteEnrollmentChart.vue';

export default {
    name: 'Dashboard',

    components: {
        EnrollmentChart,
        SiteEnrollmentChart,
    },

    data() {
        return {
            isLoading: true,
            study: null,
            studyStatuses,
            stratums,
        };
    },

    beforeMount() {
        this.getStudy(this.$route.query.name, this.$route.query.domain, this.$route.query.token).then((response) => {
            this.study = response.data;

            this.isLoading = false;
        }).catch((error) => {
            console.error(error);

            this.$router.push({
                name: '404',
            });
        });
    },

    methods: {
        getStudy: studyService.getStudy,

        getImgUrl(fileName) {
            // eslint-disable-next-line global-require,import/no-dynamic-require
            return require(`../assets/img/${fileName}`);
        },

        getPatientCount: utils.getPatientCount,

        getEnrollmentForStratum(stratum) {
            return this._.filter(this.study.patientEnrollments, (pe) => pe.stratum === stratum.key);
        },
    },
};
</script>

<style scoped>
.loading-text {
  font-size: 24px;
  margin-top: 20px;
  text-align: center;
}

.html-content img {
  max-width: 100%;
}

.stage-wrapper {
  width: 100%;
}

.stage {
  width: 100%;
  padding: 30px;
  display:flex;
  flex-direction: row;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.stage {
  position: relative;
  top: -50px;
  margin-top: 49px;
}

.stage.active {
  border: 3px solid #009FDF;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.stage:not(:last-child):after {
  content: "";
  position: absolute;
  z-index: 6;
  top: 100%;
  bottom: -100%;
  height: 50px;
  left: 50%;
  border-left: 3px solid #C4C4C4;
  transform: translate(-50%);
}

.stage.active:after {
  top: calc(100% + 3px);
}

.stage img {
  width: 50px;
}

.stage b {
  font-size: 18px;
  margin-left: 20px;
}

.enrollment-wrapper {
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.enrollment-wrapper b {
  font-size: 24px;
  display: block;
}

.enrollment-chart {
  height: 400px;
}

.legend {
  display: flex;
  justify-content: space-around;
}

.legend > div {
  display: flex;
  align-items: center;
  padding-bottom: 15px;
}

.legend span {
  font-size: 18px;
  line-height: 18px;
  margin-left: 10px;
}

.legend .box {
  width: 13px;
  height: 13px;
}

.kpi {
  font-weight: bold;
  color: #b90066;
}

.site-enrollment-wrapper {
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.site-enrollment-wrapper:not(:last-of-type) {
  margin-bottom: 30px;
}

.site-enrollment-wrapper .meta-data b {
  font-size: 24px;
  display: block;
}

.meta-data {
  user-select: none;
}

.site-enrollment-chart {
  height: 700px;
}

h1 {
  font-weight: bold;
  font-size: 28px;
}

h3 {
  font-weight: bold;
  font-size: 18px;
}
</style>
